import { useEffect, useState } from 'react';
import { getCalApi } from '@calcom/embed-react';
import { MdEvent } from 'react-icons/md';
import calConfig from '../../config/calConfig';
import { trackCalBookings } from '../../analytics';
import './CalFloatingButton.scss';

const CalFloatingButton = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    (async function () {
      const cal = await getCalApi({ namespace: calConfig.namespace });
      cal('ui', { hideEventTypeDetails: false, layout: 'month_view' });
      trackCalBookings(cal);
    })();
  }, []);

  return (
    <div 
      className={`cal-button-wrapper ${isExpanded ? 'expanded' : ''}`}
      onMouseEnter={() => setIsExpanded(true)}
      onMouseLeave={() => setIsExpanded(false)}
    >
      <button
        className="cal-booking-btn"
        data-cal-namespace={calConfig.namespace}
        data-cal-link={calConfig.calLink}
        data-cal-config='{"layout":"month_view"}'
        aria-label="Reservar Asesoría Jurídica"
      >
        <MdEvent className="cal-icon" />
        {isExpanded && <span className="cal-text">Asesoría</span>}
      </button>
    </div>
  );
};

export default CalFloatingButton;
